import { useCallback, useEffect, useRef, useState } from 'react';

export type RenderingsMobileStep = 'options' | 'preview';

type UseRenderingsMobileNavigationOptions = {
  isMobileView: boolean;
  isRenderingInProgress: boolean;
  hasRenderedResult: boolean;
};

export const useRenderingsMobileNavigation = ({
  isMobileView,
  isRenderingInProgress,
  hasRenderedResult,
}: UseRenderingsMobileNavigationOptions) => {
  const [mobileStep, setMobileStep] = useState<RenderingsMobileStep>('options');
  const wasMobileRef = useRef(isMobileView);

  const goToPreview = useCallback(() => {
    setMobileStep('preview');
  }, []);

  const goToOptions = useCallback(() => {
    setMobileStep('options');
  }, []);

  const handleBack = useCallback(() => {
    goToOptions();
  }, [goToOptions]);

  const handleChange = useCallback(() => {
    goToOptions();
  }, [goToOptions]);

  useEffect(() => {
    const wasMobile = wasMobileRef.current;
    wasMobileRef.current = isMobileView;

    if (!isMobileView) return;

    if (!wasMobile && isMobileView) {
      if (isRenderingInProgress || hasRenderedResult) {
        setMobileStep('preview');
      } else {
        setMobileStep('options');
      }
    }
  }, [hasRenderedResult, isMobileView, isRenderingInProgress]);

  const effectiveStep: RenderingsMobileStep = isMobileView ? mobileStep : 'preview';

  return {
    mobileStep: effectiveStep,
    goToPreview,
    goToOptions,
    handleBack,
    handleChange,
    showMobilePreviewChrome: isMobileView && effectiveStep === 'preview',
    showMobileOptionsOnly: isMobileView && effectiveStep === 'options',
  };
};
